module.exports = __webpack_public_path__ + "static/media/appstore.f5f256ed.svg";